import React, { useState } from 'react';
import { submitForm } from '../utils/api';
import './FormPage.css';

// Create a simplified form component for testing
const Form = ({ formData, onSubmit }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name, email, message });
  };
  
  return (
    <div className="form-container">
      <h2>{formData.title || 'Contact Form'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label>Name</label>
          <input 
            type="text" 
            value={name} 
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label>Email</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label>Message</label>
          <textarea 
            value={message} 
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

const ContactFormPage = () => {
  const [apiEnvironment, setApiEnvironment] = useState('simulation');
  const [submissionResult, setSubmissionResult] = useState(null);
  
  const contactFormData = {
    title: 'Contact Form',
    description: 'Please fill out this form to get in touch with us.'
  };
  
  const handleSubmit = async (formValues) => {
    console.log('Contact form values:', formValues);
    
    try {
      // Submit to the selected API environment
      const result = await submitForm('contact', formValues, null, apiEnvironment);
      console.log('Submission result:', result);
      setSubmissionResult(result);
      return result;
    } catch (error) {
      console.error('Submission error:', error);
      setSubmissionResult({
        success: false,
        message: error.message || 'An unknown error occurred'
      });
      throw error;
    }
  };
  
  return (
    <div>
      <h1 className="page-title">Contact Form Example</h1>
      
      <div className="page-description">
        <p>This example demonstrates a standard contact form with various field types and validation rules. It's a common pattern for collecting user inquiries on websites and applications.</p>
      </div>
      
      <div className="form-options">
        <div className="option-group">
          <label htmlFor="api-environment">API Environment:</label>
          <select
            id="api-environment"
            value={apiEnvironment}
            onChange={(e) => setApiEnvironment(e.target.value)}
          >
            <option value="simulation">Simulation (No API)</option>
            <option value="local">Local API (http://localhost:8787)</option>
            <option value="production">Production API</option>
          </select>
        </div>
      </div>
      
      {submissionResult && (
        <div className={`submission-result ${submissionResult.success ? 'success' : 'error'}`}>
          <h3>{submissionResult.success ? 'Submission Successful' : 'Submission Failed'}</h3>
          <p>{submissionResult.message}</p>
          {submissionResult.id && <p>Reference ID: {submissionResult.id}</p>}
        </div>
      )}
      
      <div className="form-container-wrapper">
        <Form
          formData={contactFormData}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default ContactFormPage; 